import { Box, useTheme } from '@mui/material'
import { TimeSlotGrid } from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/components/prescriptionMakingPageComponents/TimeSlotGrid'

const CalendarView = ({
  bookingDate,
  selectedDate,
  setSelectedDate,
  onSlotSelect,
  currentEventTypeObject,
  mentorProfile,
  currentBookedEventId,
  clinicLocation = null, // Clinic location for timezone
  bookedSlots = [], // Booked slots to disable overlapping slots
  bookedSlotsLoading = false, // Loading state for booked slots
}) => {
  const theme = useTheme()

  return (
      <TimeSlotGrid
        minDate={bookingDate}
        maxDate={bookingDate.add(1, 'month')}
        instructionsDiv={
          <Box
            style={{
              marginBottom: '15px',
              padding: '12px',
              backgroundColor: '#e2dfff',
              borderRadius: '8px',
              border: `1px solid rgb(202 197 253)`,
            }}
          >
            <div
              style={{
                fontSize: '14px',
                color: theme.palette.emrPrimary.main,
                fontWeight: 'bold',
              }}
            >
              📅 Select a time slot to hold
            </div>
            <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
              Click on a time slot below to hold a slot for the patient for that time
            </div>
          </Box>
        }
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        onSlotSelect={onSlotSelect}
        eventDuration={currentEventTypeObject?.durationInMins || 30}
        mentorProfile={mentorProfile}
        currentBookedEventId={currentBookedEventId}
        currentEventTypeObject={currentEventTypeObject}
        clinicLocation={clinicLocation}
        bookedSlots={bookedSlots}
        bookedSlotsLoading={bookedSlotsLoading}
      />
  )
}

export default CalendarView
